import React from "react";
import "../styles/PopupModal.css";

const PopupModal = ({ title, message, type = "info", onClose, onConfirm }) => {
  return (
    <div className="popup-overlay">
      <div className={`popup-container ${type}`}>
        <h3 className="popup-title">{title}</h3>
        <p className="popup-message">{message}</p>

        <div className="popup-actions">
          {onConfirm ? (
            <>
              <button className="popup-btn cancel" onClick={onClose}>Cancel</button>
              <button className="popup-btn confirm" onClick={onConfirm}>Confirm</button>
            </>
          ) : (
            <button className="popup-btn ok" onClick={onClose}>OK</button>
          )}
        </div>
      </div>
    </div>
  );
};

export default PopupModal;
